export { default } from './footer-masthead';
